import "./Gallery.css";

const GCS_BASE_URL = "https://storage.googleapis.com/portfolio-media-circus";

function GalleryItem({ filePath, fileName, style, isVideo, alt }) {
  const src = filePath || (fileName ? `${GCS_BASE_URL}/${fileName}` : null);

  if (!src) return null;

  if (isVideo) {
    return (
      <video autoPlay muted loop style={style}>
        <source src={src} type="video/mp4"></source>
      </video>
    );
  }

  return <img src={src} style={style} alt={alt || "Gallery image"} />;
}

export default GalleryItem;
